import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { RETAILER_COLORS, SCREEN_SIZE } from '@components/web/src/styles';

export const HeaderKioskContainer = styled(Flexbox)`
  position: sticky;
  top: 0;
  z-index: 9999;
  width: 100%;
  max-width: ${SCREEN_SIZE.KIOSK_WIDTH};
  min-height: 60px;
  max-height: 60px;
  background-color: ${RETAILER_COLORS.secondary['100']};
`;

export const LogoWrapper = styled.button`
  all: unset;
  height: 30.8px;
`;
